<ng-container *transloco="let t">
    <td-alert class="error" state="danger" *ngIf="message" [title]="title || t('error.default-title')">
        <div class="d-flex align-items-center">
            <div [tdDynamicHtml]="message"></div>
        </div>
    </td-alert>
</ng-container>
